import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Dropdown, DropdownButton, Form,  Modal, Row, Table } from "react-bootstrap";
import { Tooltip } from 'react-tooltip'
import { PencilIcon } from '@primer/octicons-react'
import { BiHelpCircle, BiPlus, BiTrash } from "react-icons/bi";
import { axiosAuth_DATA_MGMT_API } from '../utils/AxoisUtilComponent';
import { axiosAuth_IDENT_MGMT_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';
import { testJSON } from '../utils/jsUtils';


const NotifTypeAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  // Initialize with actual JSON obj.  If not, will get error.
  const [notifTypeAttrs, setNotifTypeAttrs] = useState({
    id: '',
    name: '',
    description: '',
    category: '',
    attrList: '',
    timeBased: true,
    msgTempalte: {}
  });

  const [currentNotifTypeAttrs, setCurrentNotifTypeAttrs] = useState({});

  const categoryOptions = [
    { key: "ALARM",     value: "ALARM" },
/*
    { key: "WORKORDER", value: "WORKORDER" },
*/
    { key: "NOTICE",    value: "NOTICE" },
    { key: "OTHER",     value: "OTHER" }
  ];

  const statusOptions = [
    { key: "ST_ENABLED",  value: "ST_ENABLED" },
    { key: "ST_DISABLED", value: "ST_DISABLED" }
  ];

  const activeTimeOptions = [
    { key: "NOTIF_OFFICE_HR",     value: "NOTIF_OFFICE_HR"    },
    { key: "NOTIF_NON_OFFICE_HR", value: "NOTIF_NON_OFFICE_HR" },
    { key: "NOTIF_AI_RECOMM_HR",  value: "NOTIF_AI_RECOMM_HR" },
    { key: "NOTIF_ALL_HR",        value: "NOTIF_ALL_HR"    }
  ];


  // View vs Edit Modes
  const [editMode, setEditMode] = useState(false);

  const [errMsg, setErrMsg] = useState('');

  //const [errMsg_Update,      setErrMsg_Update]      = useState('');

  //const [msgTemplates, setMsgTemplates] = useState();

  const [ugroupList, setUgroupList] = useState([]);

  //const [showUgroupInfo, setShowUgroupInfo] = useState(false);
  //const [ugroupSelected, setUgroupSelected] = useState();

  const [ugroupAddList, setUgroupAddList] = useState([]);

  const [unassignedUgroupList, setUnassignedUgroupList] = useState();

  const [showAddUgroupDialog, setShowAddUgroupDialog] = useState(false);
  const [addUgroupErrMsg, setAddUgroupErrMsg] = useState('');


  // UI Functions

  // Initialize state
  useEffect(() => {

    if (props) {
      setNotifTypeAttrs(props.objDetails);
      setCurrentNotifTypeAttrs(props.objDetails);

      fetchAssociatedUgroups(props.objDetails.id);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);


  const fetchAssociatedUgroups = (notifTypeId) => {

    if (!notifTypeId) {
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types/" + notifTypeId + "/usergroups");

        resolve(res.data);

        if (res.status === 200) {
          setUgroupList(res.data);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const fetchUnassignedUgroups = () => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_IDENT_MGMT_API.get("usergroups");

        resolve(res.data);

        if (res.status === 200) {

          // Assign to a cleanList in case there are group entries are reserved.  But nothing at this moment.
          const cleanList = res.data;

          // Remove datapoint types already assigned to the user
          let tmpList = [];

          for (let i=0; i<ugroupList.length; i++) {
            tmpList.push(ugroupList[i].id);
          }

          let newList = [];
          for (let i=0; i<cleanList.length; i++) {
            if (!tmpList.includes(cleanList[i].id)) {
              cleanList[i].activeTime = 'NOTIF_ALL_HR';
              newList.push(cleanList[i]);
            }
          }

          setUnassignedUgroupList(newList);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const handleEditAttrs = (e) => {
    e.preventDefault();
    setEditMode(true);
  }


  const onAttrsInputChange = (e) => {
    setNotifTypeAttrs({ ...notifTypeAttrs, [e.target.name]: e.target.value });
  }

/*
  const onMsgTemplatesInputChange = (e) => {
    setMsgTemplates(e.target.value);
  }
*/

  const onMsgTemplatesEmailSubject = (e) => {
    // Deep copy
    let tmpMsgTemplate =  JSON.parse (JSON.stringify(notifTypeAttrs.msgTemplates));

    if (!tmpMsgTemplate.email)
      tmpMsgTemplate.email = {}

    tmpMsgTemplate.email.subject = e.target.value;

    setNotifTypeAttrs({ ...notifTypeAttrs, msgTemplates: tmpMsgTemplate });
  }

  const onMsgTemplatesEmailBody = (e) => {
    // Deep copy
    let tmpMsgTemplate =  JSON.parse (JSON.stringify(notifTypeAttrs.msgTemplates));

    if (!tmpMsgTemplate.email)
      tmpMsgTemplate.email = {}

    tmpMsgTemplate.email.body = e.target.value;

    setNotifTypeAttrs({ ...notifTypeAttrs, msgTemplates: tmpMsgTemplate });
  }

  const onMsgTemplatesSMS = (e) => {
    // Deep copy
    let tmpMsgTemplate =  JSON.parse (JSON.stringify(notifTypeAttrs.msgTemplates));

    if (!tmpMsgTemplate.sms)
      tmpMsgTemplate.sms = {}

    tmpMsgTemplate.sms.body = e.target.value;

    setNotifTypeAttrs({ ...notifTypeAttrs, msgTemplates: tmpMsgTemplate });
  }

/*
  const onCheckboxSelect = (e) => {
    setNotifTypeAttrs({ ...notifTypeAttrs, [e.target.name]: e.target.checked });
  }
*/

  const onCategorySelect = (key, event) => {
    setNotifTypeAttrs({ ...notifTypeAttrs, category: key });
  }

  const onStatusSelect = (key, event) => {
    setNotifTypeAttrs({ ...notifTypeAttrs, status: key });
  }


  const handleEditCancel = (e) => {
    e.preventDefault();

    // Reset fields
    setNotifTypeAttrs(currentNotifTypeAttrs);
    //setMsgTemplates(currentNotifTypeAttrs.msgTemplates);

    setEditMode(false);
  }

  const handleEditSubmit = (e) => {
    e.preventDefault();

    if (!notifTypeAttrs.name || notifTypeAttrs.name.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_name"));
    } else if (notifTypeAttrs.name.length > 50) {
      setErrMsg(t("I18N_ERR_Max_len_name") + 50);
    } else if (!notifTypeAttrs.description || notifTypeAttrs.description.trim().length === 0) {
      setErrMsg(t("I18N_ERR_Need_description"));
    } else if (notifTypeAttrs.description.length > 200) {
      setErrMsg(t("I18N_ERR_Max_len_desc") + 200);
    } else if (!notifTypeAttrs.status || notifTypeAttrs.status.length === 0) {
      setErrMsg(t("I18N_ERR_Need_status"));
    } else if (!notifTypeAttrs.category || notifTypeAttrs.category.length === 0) {
      setErrMsg(t("I18N_ERR_Need_category"));
    } else if (   !notifTypeAttrs.msgTemplates
               || (!notifTypeAttrs.msgTemplates.email && !notifTypeAttrs.msgTemplates.sms)
               || (   (   !notifTypeAttrs.msgTemplates.email
                       || (   notifTypeAttrs.msgTemplates.email
                           && (!notifTypeAttrs.msgTemplates.email.body || notifTypeAttrs.msgTemplates.email.body.trim().length === 0)))
                   && (   !notifTypeAttrs.msgTemplates.sms
                       || (   notifTypeAttrs.msgTemplates.sms
                           && (!notifTypeAttrs.msgTemplates.sms.body   || notifTypeAttrs.msgTemplates.sms.body.trim().length   === 0))))) {
      // If both the email body and sms body are empty, return error
      setErrMsg(t("I18N_ERR_Need_msgTemplate"));
    } else if (Object.keys(notifTypeAttrs.msgTemplates).length === 0) {
      setErrMsg(t("I18N_ERR_Need_msgTemplate"));
    } else {
      validateName();
    }

    return;
  }

  // Since this is async, need to call this first, and check the others when username availability returns
  function validateName() {

    if (notifTypeAttrs.name === currentNotifTypeAttrs.name) {
      // No name change, no need to check
      validateOtherFields();
      return;
    } else {
      new Promise(async (resolve, reject) => {
        try {
          const res = await axiosAuth_DATA_MGMT_API.get("notif-types?name=" + notifTypeAttrs.name);

          resolve(res.data);

          if (res.data && res.data.length > 0) {
            // NotifType name is taken
            setErrMsg(t("I18N_ERR_Name_taken"));
            return;
          } else {
            validateOtherFields();
            return;
          }
        } catch (error) {
          if (!error.message || (error.message !== 'IGNORE')) {
            setErrMsg(t(translateAPIError(error)));
            validateOtherFields();
          }
          return;
        }
      });
    }
  }

  function validateOtherFields() {
    // Validate form inputs

    updateNotifType();
  }

  const updateNotifType = () => {

    const reqBody = notifTypeAttrs;

    if (!testJSON(JSON.stringify(reqBody.msgTemplates))) {
      setErrMsg(t("I18N_ERR_Msg_templates_invalid_JSON"));
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.put("notif-types/" + notifTypeAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setEditMode(false);
          fetchObj(notifTypeAttrs.id);
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });

  }

  const fetchObj = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("notif-types/" + id);

        resolve(res.data);

        if (res.status === 200) {
          setNotifTypeAttrs(res.data[0]);
          setCurrentNotifTypeAttrs(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }



/*
  function handleUgroupInfo(ugroup) {
    setUgroupSelected(ugroup);
    setShowUgroupInfo(true);
  }

  const handleUgroupInfoClose = (e) => {
    setUgroupSelected(null);
    setShowUgroupInfo(false);
  }
*/


  function handleAddUgroups() {
    fetchUnassignedUgroups();
    setShowAddUgroupDialog(true);
  }

  function handleAddUgroupsClose() {
    setUgroupAddList([]);
    setShowAddUgroupDialog(false);
  }

  function handleAddUgroupsSubmit() {
    let ugroupList = [];

    if (ugroupAddList.length === 0) {
      setShowAddUgroupDialog(false);
      return;
    }

    for (let i=0; i<ugroupAddList.length; i++) {
      let activeTime = unassignedUgroupList.find( item => item.id.toString() === ugroupAddList[i].toString()).activeTime;
      ugroupList.push({id: ugroupAddList[i],
                       activeTime: activeTime});
    }

    let reqBody = {
          usergroups: ugroupList
        };

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.post("notif-types/" + notifTypeAttrs.id + "/usergroups", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setUgroupAddList([]);
          setAddUgroupErrMsg('');
          setShowAddUgroupDialog(false);
          fetchAssociatedUgroups(notifTypeAttrs.id);
          fetchUnassignedUgroups();
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setAddUgroupErrMsg(t(translateAPIError(error)));
      }
    });
  }


  function handleRemoveUgroup(ugroup) {

    let reqBody = {
          data: {
             "usergroupIds": []
          }
        };

    reqBody.data.usergroupIds.push(ugroup.id);

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.delete("notif-types/" + notifTypeAttrs.id + "/usergroups/", reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg('');
          fetchAssociatedUgroups(notifTypeAttrs.id);
        } else {
          // ##### NEED TO DECIDE WHAT TO DO #####
        }
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }

  const handleUgroupSelect = (e) => {

    if (e.target.checked) {
      // Add ugroup to the list
      ugroupAddList.push(e.target.id);
    } else {
      const index = ugroupAddList.indexOf(e.target.id);
      if (index > -1) {
        ugroupAddList.splice(index, 1);
      }
    }

    setUgroupAddList(ugroupAddList);
  }


  function renderUgroup(ugroup, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
{/*
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleUgroupInfo(ugroup)}>{ugroup.name}</span></td>
*/}
        <td>{ugroup.name}</td>
        <td>{ugroup.description}</td>
        <td>{t("I18N_" + ugroup.activeTime)}</td>
        <td><span style={{cursor:'pointer', color:'SteelBlue'}} onClick={() => handleRemoveUgroup(ugroup)}><BiTrash size={16} /></span></td>
      </tr>
    )
  }

  const onActiveTimeSelect = (e,ugroup) => {
    let newList = [];

    // ##### THIS IS A VERY EXPENSIVE WAY OF REGISTER CHANGE.  THERE MUST BE A BETTER WAY #####
    for (let i=0; i<unassignedUgroupList.length; i++) {
      let deepCopyUgroup = JSON.parse(JSON.stringify(unassignedUgroupList[i]));

      if (unassignedUgroupList[i].id === ugroup.id) {
        deepCopyUgroup.activeTime = e; 
      }

      newList.push(deepCopyUgroup);
    }

    setUnassignedUgroupList (newList);
  }


  function renderAddUgroups(ugroup, index) {
    return (
      <tr key={index} style={{fontWeight:'300'}}>
        <td><Form.Check type="checkbox" id={ugroup.id} label="" onChange={handleUgroupSelect} /></td>
        <td>{ugroup.name}</td>
        <td>{ugroup.description}</td>
        <td>
          <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
            title={!ugroup.activeTime ? t("common:I18N_DROPDOWN_PROMPT") : t("I18N_" + ugroup.activeTime)}
            onSelect={e => onActiveTimeSelect(e, ugroup)}>
            {activeTimeOptions.map((item, index) => {
              return (
                <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                  {t("I18N_" + item.value)}
                </Dropdown.Item>
              );
            })}
          </DropdownButton>
        </td>
      </tr>
    )
  }


  return (
    <>
      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
        <span className={classes.admin_pages__page_title}>
          {t("I18N_Notiftype_Details")}
        </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Notiftype_info")}
            </span>
            {editMode ?
              null
              :
              <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditAttrs}>
                <PencilIcon size={12} />
                {t("I18N_Edit")}
              </span>
            }
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          {editMode ?
            <Container>
              <form>
                <Row className={classes.admin_pages__field_label}>
                  <Col md={3}>{t("I18N_Name")}: *</Col>
                  <Col md={3}>{t("I18N_Description")}: *</Col>
{/* Removed this feature.  Now always time based.
                  <Col md={3}>{t("I18N_Time_based")}: *</Col>
*/}
                  <Col md={3}>{t("I18N_Notif_type_cat")}: *</Col>
                  <Col md={3}>
                  </Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="name" value={notifTypeAttrs.name}
                      onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                  <Col md={3}>
                    <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="description"
                              value={notifTypeAttrs.description}
                              onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
{/* Removed this feature.  Now always time based.
                  <Col md={3}>
                    <Form.Check type="switch" name={"timeBased"} checked={notifTypeAttrs.timeBased}
                                onChange={onCheckboxSelect} />
                  </Col>
*/}
                  <Col md={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!notifTypeAttrs.category ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + categoryOptions.find( ({ key }) => key === notifTypeAttrs.category ).value)}
                      onSelect={onCategorySelect}>
                      {categoryOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col md={3}>
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label}>
                  <Col md={3}>{t("I18N_Status")}: *</Col>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col md={3}>
                    <DropdownButton size="tiny_dropdown" variant="outline-secondary" id="dropdown-basic-button"
                      title={!notifTypeAttrs.status ? t("common:I18N_DROPDOWN_PROMPT") :
                              t("I18N_" + (statusOptions.find( ({ key }) => key === notifTypeAttrs.status )).value)}
                      onSelect={onStatusSelect}>
                      {statusOptions.map((item, index) => {
                        return (
                          <Dropdown.Item key={index} eventKey={item.key} className={classes.dropdown_item_wrap}>
                            {t("I18N_" + item.value)}
                          </Dropdown.Item>
                        );
                      })}
                    </DropdownButton>
                  </Col>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                  <Col md={3}></Col>
                </Row>

{/* No longer needed.
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 12}}>{t("I18N_Attr_list")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col sm={{span: 12}}>
                    <textarea rows={2} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="attrList"
                              value={notifTypeAttrs.attrList} onChange={(e) => onAttrsInputChange(e)} />
                  </Col>
                </Row>
*/}

{/*
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 12}}>{t("I18N_Msg_templates")}:</Col>
                </Row>
                <Row className={classes.admin_pages__field_value}>
                  <Col sm={{span: 12}}>
                    <textarea rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="msgTemplates"
                              value={msgTemplates} onChange={(e) => onMsgTemplatesInputChange(e)} />
                  </Col>
                </Row>
*/}
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 12}}>
                    <span>{t("I18N_Msg_templates")}: *</span>
                    <span style={{marginLeft:'5px'}} data-tooltip-id="my-tooltip" data-tooltip-html={t("I18N_TIP_Notif_template_var")} >
                      <BiHelpCircle size={14} />
                    </span>
                    <Tooltip id="my-tooltip" />
                 </Col>
                </Row>
                <div style={{marginLeft: '0px', marginTop: '5px', padding: '10px', border:'1px solid #AAA', borderRadius:'5px' }}>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '0px', textDecorationLine: 'underline' }}>
                    <Col sm={{span: 12}}>{t("I18N_Email")}</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col sm={{span: 1}}>{t("I18N_Subject")}:</Col>
                    <Col sm={{span: 11}}>
                      <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code"
                        value={notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.email ? notifTypeAttrs.msgTemplates.email.subject : ''}
                        onChange={(e) => onMsgTemplatesEmailSubject(e)} />
                    </Col>
                  </Row>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col sm={{span: 1}}>{t("I18N_Msg_body")}:</Col>
                    <Col sm={{span: 11}}>
                      <textarea rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="msgTemplates"
                                value={notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.email ? notifTypeAttrs.msgTemplates.email.body : ''} onChange={(e) => onMsgTemplatesEmailBody(e)} />
                    </Col>
                  </Row>

                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', textDecorationLine: 'underline' }}>
                    <Col sm={{span: 12}}>{t("I18N_SMS")}</Col>
                  </Row>
                  <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                    <Col sm={{span: 1}}>{t("I18N_Msg_body")}:</Col>
                    <Col sm={{span: 11}}>
                      <input className={classes.admin_pages__field_editable} style={{width:'100%'}} name="code"
                        value={notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.sms ? notifTypeAttrs.msgTemplates.sms.body : ''}
                        onChange={(e) => onMsgTemplatesSMS(e)} />
                    </Col>
                  </Row>
                </div>

                <Row className={classes.admin_pages__field_label} style={{marginTop:'10px', fontStyle:'italic'}}>
                  <span>{t("I18N_Req_fields")}</span>
                </Row>

                <Row>
                  <div display='flex' style={{marginTop:'15px'}}>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ float: 'left' }}
                      onClick={handleEditCancel}>
                      {t("I18N_Cancel")}
                    </Button>
                    <Button size="tiny" variant="outline-secondary" className="mb-3"
                      style={{ marginLeft: '15px' }}
                      onClick={handleEditSubmit}>
                      {t("I18N_Save")}
                    </Button>
                    <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                      {errMsg}
                    </span>
                  </div>
                </Row>
              </form>
            </Container>
            :
            <Container>
              <Row className={classes.admin_pages__field_label}>
                <Col md={3}>{t("I18N_Name")}:</Col>
                <Col md={3}>{t("I18N_Description")}:</Col>
{/* Removed this feature.  Now always time based.
                <Col md={3}>{t("I18N_Time_based")}:</Col>
*/}
                <Col md={3}>{t("I18N_Notif_type_cat")}:</Col>
                <Col md={3}>
                </Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{notifTypeAttrs.name}</Col>
                <Col style={{maxHeight:'80px', overflow:'auto', flexWrap:'wrap', wordWrap:'break-word'}}>
                  {notifTypeAttrs.description}
                </Col>
{/* Removed this feature.  Now always time based.
                <Col md={3}>
                  {notifTypeAttrs.timeBased ? t("I18N_Yes") : t("I18N_No")}
                </Col>
*/}
                <Col md={3}>
                  {t("I18N_" + notifTypeAttrs.category)}
                </Col>
                <Col md={3}>
                </Col>
              </Row>

              <Row className={classes.admin_pages__field_label}>
                <Col md={3}>{t("I18N_Status")}:</Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col md={3}>{t("I18N_" + notifTypeAttrs.status)}</Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
                <Col md={3}></Col>
              </Row>

{/* No longer needed.
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 12}}>{t("I18N_Attr_list")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={{span: 12}}>
                  <textarea readOnly rows={2} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="attrList"
                            value={notifTypeAttrs.attrList} onChange={(e) => onAttrsInputChange(e)} />
                </Col>
              </Row>
*/}

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={{span: 12}}>
                  {t("I18N_Msg_templates")}:
                  <span style={{marginLeft:'5px'}} data-tooltip-id="my-tooltip" data-tooltip-html={t("I18N_TIP_Notif_template_var")} >
                    <BiHelpCircle size={14} />
                  </span>
                  <Tooltip id="my-tooltip" />
                </Col>
              </Row>
              <div style={{marginLeft: '0px', marginTop: '5px', padding: '10px', border:'1px solid #AAA', borderRadius:'5px' }}>
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '0px', textDecorationLine: 'underline' }}>
                  <Col sm={{span: 12}}>{t("I18N_Email")}</Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 1}}>{t("I18N_Subject")}:</Col>
                  <Col sm={{span: 11}}><span>{(notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.email) ? notifTypeAttrs.msgTemplates.email.subject : ''}</span></Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 1}}>{t("I18N_Msg_body")}:</Col>
                  <Col sm={{span: 11}}>
                    <textarea readOnly rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="emailBody"
                              value={notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.email ? notifTypeAttrs.msgTemplates.email.body : ''} />
                  </Col>
                </Row>

                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px', textDecorationLine: 'underline' }}>
                  <Col sm={{span: 12}}>{t("I18N_SMS")}</Col>
                </Row>
                <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                  <Col sm={{span: 1}}>{t("I18N_Msg_body")}:</Col>
                  <Col sm={{span: 11}}><span>{(notifTypeAttrs.msgTemplates && notifTypeAttrs.msgTemplates.sms) ? notifTypeAttrs.msgTemplates.sms.body : ''}</span></Col>
                </Row>
              </div>

{/*
              <Row className={classes.admin_pages__field_value}>
                <Col sm={{span: 12}}>
                  <textarea readOnly rows={6} className={classes.admin_pages__field_editable} style={{minWidth: '100%'}} name="msgTemplates"
                            value={msgTemplates} />
                </Col>
              </Row>
*/}

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col>{t("I18N_Created_by")}:</Col>
                <Col>{t("I18N_Time_created")}:</Col>
                <Col>{t("I18N_Updated_by")}:</Col>
                <Col>{t("I18N_Time_updated")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col style={{overflowWrap:'anywhere'}}>{notifTypeAttrs.creatorUsername}</Col>
                <Col>{formatDate(notifTypeAttrs.timeCreated)}</Col>
                <Col style={{overflowWrap:'anywhere'}}>{notifTypeAttrs.updaterUsername}</Col>
                <Col>{formatDate(notifTypeAttrs.timeUpdated)}</Col>
              </Row>

            </Container>
          }
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'30px'}}>
          <div style={{display:'flex'}}>
            <span>
              {t("I18N_Ugroup_assoc_with_notif_type")}
            </span>
            <span style={{marginLeft:'auto', marginRight:'20px'}}>
              <span onClick={handleAddUgroups} style={{marginLeft:'5px'}} data-tooltip-id="tooltip-add-ugroup" data-tooltip-html={t("I18N_TIP_Add_usergroup")} >
                <BiPlus size={18} />
              </span>
              <Tooltip id="tooltip-add-ugroup" />
            </span>
          </div>

          <hr className="solid" style={{ margin: '0 0 0 0' }}></hr>

          <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>

            <Table hover responsive size="sm">
              <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                <tr>
                  <th style={{fontWeight:'400'}}>{t("I18N_Name")}</th>
                  <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                  <th style={{fontWeight:'400'}}>{t("I18N_Active_time")}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {(ugroupList && ugroupList.length > 0) ? ugroupList.map(renderUgroup) : null}
              </tbody>
            </Table>
          </div>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>
            </div>
{/*
              <span className={classes.admin_pages__field_label} style={{ color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {updateNotifTypeErrMsg}
              </span>
*/}
          </Form.Group>
        </div>

        <Modal show={showAddUgroupDialog} onHide={handleAddUgroupsClose} centered >
          <Modal.Body>

            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <div display='flex'>
                <span>
                  {t("I18N_User_groups")}
                </span>
              </div>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>
            </div>

            <div style={{overflow:'auto', fontSize:'11px', marginTop:'10px'}}>
              <Table hover responsive size="sm">
                <thead style={{color:'#686868', fontSize:'12px', borderBottom:"2px solid #D0D0D0"}}>
                  <tr>
                    <th></th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Name")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Description")}</th>
                    <th style={{fontWeight:'400'}}>{t("I18N_Active_time")}</th>
                  </tr>
                </thead>
                <tbody>
                  {unassignedUgroupList ? unassignedUgroupList.map(renderAddUgroups) : null}
                </tbody>
              </Table>
            </div>

            <div display='flex' style={{ marginTop: '15px' }}>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ float: 'left' }}
                onClick={handleAddUgroupsClose}>
                {t("I18N_Cancel")}
              </Button>
              <Button size="tiny" variant="outline-secondary" className="mb-3"
                style={{ marginLeft: '15px' }}
                onClick={handleAddUgroupsSubmit}>
                {t("I18N_Add_user_groups")}
              </Button>
              <span className={classes.admin_pages__field_label} style={{ marginLeft: '30px', color: 'rgba(200,0,0)', verticalAlign: 'top' }}>
                {addUgroupErrMsg}
              </span>
            </div>
          </Modal.Body>
        </Modal>

      </Card>
    </>
  );
}
 
export default NotifTypeAdminDetailsView;
